























































































import {Vue, Component, Watch} from 'vue-property-decorator';
import PageTitle from '@/components/common/PageTitle.vue';
import MallsTab from '@/components/common/MallsTab.vue';
import ItemTable from '@/components/common/ItemTable.vue';
import {Mall, GetMailUsagesViewRequest, GetMallsDataRequest} from 'supporter';
import {MailUsagesView} from '@/types';
import {i18nInObjectList} from '@/utils/i18n';
import {getSelectYears, getSelectMonths} from '@/utils/dateUtils';
import {State, namespace} from 'vuex-class';
const mallModule = namespace('mall');
@Component({
  components: {
    PageTitle,
    MallsTab,
    ItemTable
  }
})
export default class UsageList extends Vue {
  @mallModule.Action('fetchMalls') fetchMalls!: () => Promise<any>;
  @State('malls', {namespace: 'mall'})
  private malls!: Mall[];
  private mallNo: number = 0;
  @State private onGnb!: boolean;
  private mailUsagesView: MailUsagesView[] = [];
  private yearArr: object[] = [];
  private monthArr: object[] = [];
  private emailUsed: boolean = false;
  private formData: GetMailUsagesViewRequest = {
    params: {
      mallNo: 0,
      year: new Date().getFullYear(),
      month: 1
    }
  };
  // ====== For grid ========
  private summaryOptions = {
    name: 'usage_summary',
    haveRigthBtn: false,
    haveDataBodyHeight: 130
  };
  private listOptions = {
    name: 'usage_list',
    haveRigthBtn: false,
    haveDataBodyHeight: 130
  };
  private gridPropsOne = {
    options: {},
    minBodyHeight: 31,
    scrollY: false,
    copyOptions: {
      useFormattedValue: true
    },
    columns: [
      {
        header: 'MAIL_USAGE_LIST_TABLE_HEADER_ONE',
        name: 'date',
        align: 'center',
        minWidth: 85
      },
      {
        header: 'MAIL_USAGE_LIST_TABLE_HEADER_TWO',
        name: 'amount',
        align: 'center',
        minWidth: 85
      },
      {
        header: 'MAIL_USAGE_LIST_TABLE_HEADER_FOUR',
        name: 'totalPrice',
        align: 'center',
        minWidth: 85
      }
    ]
  };
  private gridPropsTwo = {
    options: {},
    scrollY: false,
    copyOptions: {
      useFormattedValue: true
    },
    columns: [
      {
        header: 'MAIL_USAGE_LIST_TABLE_HEADER_ONE',
        name: 'date',
        align: 'center',
        minWidth: 20
      },
      {
        header: 'MAIL_USAGE_LIST_TABLE_HEADER_TWO',
        name: 'amount',
        align: 'center',
        minWidth: 85
      },
      {
        header: 'MAIL_USAGE_LIST_TABLE_HEADER_THREE',
        name: 'price',
        align: 'center',
        minWidth: 85
      },
      {
        header: 'MAIL_USAGE_LIST_TABLE_HEADER_FOUR',
        name: 'totalPrice',
        align: 'center',
        minWidth: 85
      }
    ]
  };

  private search(): void {
    this.getMailUsagesView();
  }
  private getMailUsagesView(): void {
    this.$api.getMailUsagesView(this.formData).then((res: any) => {
      let theObj = {
        date: this.formData.params.year + '' + this.$t('MAIL_USAGE_LIST_YEAR') + this.formData.params.month + this.$t('MAIL_USAGE_LIST_MONTH'),
        amount: res.data.amount + this.$t('COMMON_CASE'),
        price: res.data.price + this.$t('MAIL_USAGE_LIST_PRICE_POINT'),
        totalPrice: res.data.totalPrice + this.$t('MAIL_USAGE_LIST_PRICE_POINT')
      };
      this.mailUsagesView = [theObj];
    });
  }
  private reset(): void {
    this.formData = {
      params: {
        mallNo: Number(this.$route.query.mallNo),
        year: new Date().getFullYear(),
        month: new Date().getMonth()
      }
    };
  }
  private async configurations() {
    const configRequest: GetMallsDataRequest = {
      params: {
        mallNo: this.mallNo
      }
    };

    await this.$api
      .getNotificationsConfigurations(configRequest)
      .then((res) => {
        this.emailUsed = res.data.emailUsed;
      })
      .catch((e: any) => {
        if (e.data.code === 'MC0002') {
          this.emailUsed = false;
        }
      });
  }
  @Watch('$route.query.mallNo', {immediate: false, deep: false})
  async onMallChanged() {
    if (this.$route.query.mallNo) {
      this.mallNo = Number(this.$route.query.mallNo);
    } else {
      this.mallNo = this.malls[0].mallNo;
    }
    this.toFirstPage();
    // await this.configurations();

  }
  private toFirstPage() {
    // console.log(this.$route.query.mallNo)
    // window.location.reload();
    let url = `/mail/dispatch?mallNo=${this.mallNo}&tabNo=1`;
    window.location.assign(url);
  }
  private created() {
    this.gridPropsOne = i18nInObjectList(this, this.gridPropsOne, 'columns', 'header');
    this.gridPropsTwo = i18nInObjectList(this, this.gridPropsTwo, 'columns', 'header');
  }

  private async mounted() {
    await this.fetchMalls();
    if (this.$route.query.mallNo) {
      this.mallNo = Number(this.$route.query.mallNo);
    } else {
      this.mallNo = this.malls[0].mallNo;
    }
    await this.configurations();
    this.formData.params.mallNo = Number(this.$route.query.mallNo);
    this.yearArr = getSelectYears(this.$t('COMMON_YEAR'));
    this.monthArr = getSelectMonths(this.$t('COMMON_MONTH'));
    this.search();    
  }
}
